// 瘦身美体
import slimmingIndex from '@/views/edit/slimming/index'

const jyRoutes = Array.from({ length: 25 }, (_, i) => ({
  path: `slimming/jy/index${i + 1}`,
  name: `slimming/jy/Index${i + 1}`,
  component: () => import(`@/views/edit/slimming/jy/index${i + 1}.vue`)
}))
const xtRoutes = Array.from({ length: 25 }, (_, i) => ({
  path: `slimming/xt/index${i + 1}`,
  name: `slimming/xt/Index${i + 1}`,
  component: () => import(`@/views/edit/slimming/xt/index${i + 1}.vue`)
}))

export default {
  path: '/edit',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: 'slimming/index',
      name: 'slimmingIndex',
      component: slimmingIndex
    },
    // 瘦身美体，开始
    ...jyRoutes,
    ...xtRoutes
    // 瘦身美体，结束

  ]
}
